<template>
  <div class="inProcess" v-if="loadingProcesses">
    <span>{{ loadingProcesses.message }}...</span>
    <vue-loaders-line-scale color="#5e72e4" scale="1"></vue-loaders-line-scale>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'loadingProcesses'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.inProcess {
  position: fixed;
  display: flex;
  align-items: center;
  bottom: 50%;
  right: 50%;
  transform: translateX(50%) translateY(-50%);
  height: 46px;
  background: white;
  border: 1px solid $borderColor1;
  padding: {
    left: 7px;
    right: 10px;
    top: 0;
  }
  z-index: 10000;
  &__img {
    width: 35px;
    height: 35px;
  }
}
</style>
